import Documentation from './Documentation';

export default Documentation;
